import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../../../translations';
@Pipe({
    name: 'vmValue',
    standalone: false
})
export class VMValuePipe implements PipeTransform {
    constructor(public TR: TranslationService) {}

    transform(value: number): string {
        return value === -1
            ? this.TR.key('subscription-manager.overview.unlimited-value')
            : value.toString();
    }
}
